import { SolButton, SolIcon } from "@solstice/sol-react";
import { FC } from "react";
import { Modal } from "ui-molecules";

type ErrorModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  errorMessage?: string;
};

export const ErrorModal : FC<ErrorModalProps> = ({isOpen, setIsOpen, errorMessage = "Something went wrong with your login, please contact the site administration."})=>{
    return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} size={"medium"}>
      <Modal.Header>
        <div className="w-full flex flex-row justify-between">
          <div className="flex flex-col">
            <h2 className="text-xl mt-1">Something went wrong</h2>
          </div>
          <SolButton variant="tertiary" onSol-click={() => setIsOpen(false)}>
            <SolIcon icon="close" />
          </SolButton>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-row space-x-4 mt-4">
          <div className="w-full">
            <p className="mb-4">
              {errorMessage}
            </p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex flex-row space-x-3 justify-end">
          <SolButton
            variant="secondary"
            className="!w-[96px] sol-w-full"
            onSol-click={() => setIsOpen(false)}
          >
            Close
          </SolButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
}